"use strict";

function MAService(serviceWrapper, campaignService) {
    var endpoint= '/api/qbe/marketing';

    function send(event, data) {

        if ( ! qbe.marketing || ! qbe.marketing.Marketing)
            return;

        //var isFullQuote = false;
        //if (data.pageName != 'vehicle.vehicle' && data.pageName != 'vehicle.drivers' && data.pageName != 'rapid-estimate')
        //    isFullQuote = true;
        var isSave = (event === 'save');
        var isfromRapidEstimate = (data.pageName === 'rapid-estimate');
        var isDeclined = (event === 'declined');

        //debugger;
        var qbeContact = {

            EmailAddress: data.policyEmail ? data.policyEmail : null,
            Enrol: false,
            Unenrol: false,
            Address : data.address ? data.address : null,
            ContactNumber : data.contactNumber ? data.contactNumber : null,
            InceptionDate : data.inceptionDate ? data.inceptionDate : null,
            Product: {

                QuoteReferenceId: data.quoteId ? data.quoteId : null,
                CoverType: data.annualResult?(data.annualResult.coverType ? data.annualResult.coverType : (data.monthlyResult.coverType ? data.monthlyResult.coverType : null)):null,
                PromotionalCode: data.campaignCode ? data.campaignCode : null,
                NoClaimBonus: data.noClaimBonus ? data.noClaimBonus : null,
                Declined: isDeclined
            }
        }

        if (!isfromRapidEstimate)
        {
            if (data.mainPolicyHolder != null) {
                qbeContact.FirstName = data.mainPolicyHolder.firstName ? data.mainPolicyHolder.firstName : null;
                qbeContact.Surname = data.mainPolicyHolder.lastName ? data.mainPolicyHolder.lastName : null;

                qbeContact.DOB = data.mainPolicyHolder.dateOfBirth ? data.mainPolicyHolder.dateOfBirth : null;

                qbeContact.State = data.state ? data.state : null;
                qbeContact.PostCode = data.postCode ? data.postCode : null;
            }

            qbeContact.SaveQuoteOutcomeId = qbe.marketing.Marketing.SaveOutcome ? qbe.marketing.Marketing.SaveOutcome : null;
            qbeContact.TriggerSaveOutcome= isSave;
            qbeContact.SaveQuoteGoalId= qbe.marketing.Marketing.SaveGoal ? qbe.marketing.Marketing.SaveGoal : null;
            qbeContact.OutcomeId= qbe.marketing.Marketing.Outcome ? qbe.marketing.Marketing.Outcome : null;
            qbeContact.EngagementPlanId= qbe.marketing.Marketing.EngagementPlan ? qbe.marketing.Marketing.EngagementPlan : null;
            qbeContact.EngagementStateId=qbe.marketing.Marketing.EngagementState ? qbe.marketing.Marketing.EngagementState : null;
            qbeContact.Unenrol= qbe.marketing.Marketing.Unenrol ? qbe.marketing.Marketing.Unenrol : false;
            qbeContact.Enrol= isSave;
            qbeContact.Product.InsuranceType= qbe.marketing.Marketing.InsuranceType;
        }

        var isFullQuote = false;
        if(data.monthlyResult && data.monthlyResult.paymentPlan && data.monthlyResult.paymentPlan.installment){
            isFullQuote = true;
        }

        // var isFullQuote = data.monthlyResult.paymentPlan.installment? true : false;

        if (isFullQuote) {
            qbeContact.Product.FullQuoteAnnualPremium = data.annualResult.totalPremium ? data.annualResult.totalPremium.toFixed(2) : null;
            qbeContact.Product.FullQuoteMonthlyPremium = data.monthlyResult.paymentPlan.installment ? data.monthlyResult.paymentPlan.installment.toFixed(2) : null;
            qbeContact.Product.FullQuoteMonthlyTotal = data.monthlyResult.totalPremium ? data.monthlyResult.totalPremium.toFixed(2) : null;

            qbeContact = createPremiumBreakdown(qbeContact, data);

        } else {
            qbeContact.Product.QuickQuoteAnnualPremium = data.annualResult?(data.annualResult.totalPremium ? data.annualResult.totalPremium.toFixed(2) : null):null;
            qbeContact.Product.QuickQuoteMonthlyPremium = data.monthlyResult?(data.monthlyResult.totalPremium ? data.monthlyResult.totalPremium.toFixed(2) : null):null;
            //qbeContact.Product.QuickQuoteMonthlyTotal = data.monthlyResult.totalPremium ? data.monthlyResult.totalPremium : null;

            qbeContact = createPremiumBreakdown(qbeContact, data);
        }

        var activeCampaign = campaignService.getCampaign() ;
        if (activeCampaign) {
           qbeContact.Product.CampaignId = activeCampaign.sc_camp;
           qbeContact.Product.CampaignHeader = activeCampaign.header;
           qbeContact.Product.CampaignImgUrl = activeCampaign.emailImageUrl ? activeCampaign.emailImageUrl : activeCampaign.imgURL;
           qbeContact.Product.CampaignTerms = activeCampaign.termsAndConditions;
       }

        var req = {
            method: 'POST',
            url: endpoint,
            data: qbeContact
        }

        serviceWrapper(req).then(function () {
            console.log('successfully called the goal API')
        }, function (error) {
            console.log(error.status + ' : ' + error.statusText);
        });
    }

    function mergeContacts(event, data) {
        try {
            send(event, data);
        } catch(ex) {
            console.log(ex) ;
        }
    }

    function createPremiumBreakdown(qbeContact, data) {
        qbeContact.Product.AnnualPremium = data.annualResult.quoteResult.premiumAfterDiscount ? data.annualResult.quoteResult.premiumAfterDiscount.toFixed(2) : null;
        qbeContact.Product.AnnualTotalFSL = data.annualResult.quoteResult.totalFSL ? data.annualResult.quoteResult.totalFSL.toFixed(2) : null;
        qbeContact.Product.AnnualTotalGST = data.annualResult.quoteResult.totalGST ? data.annualResult.quoteResult.totalGST.toFixed(2) : null;
        qbeContact.Product.AnnualStampDuty = data.annualResult.quoteResult.totalStampDuty ? data.annualResult.quoteResult.totalStampDuty.toFixed(2) : null;
        qbeContact.Product.MonthlyPremium = data.monthlyResult.quoteResult.premiumAfterDiscount ? data.monthlyResult.quoteResult.premiumAfterDiscount.toFixed(2) : null;
        qbeContact.Product.MonthlyTotalFSL = data.monthlyResult.quoteResult.totalFSL ? data.monthlyResult.quoteResult.totalFSL.toFixed(2) : null;
        qbeContact.Product.MonthlyTotalGST = data.monthlyResult.quoteResult.totalGST ? data.monthlyResult.quoteResult.totalGST.toFixed(2) : null;
        qbeContact.Product.MonthlyStampDuty = data.monthlyResult.quoteResult.totalStampDuty ? data.monthlyResult.quoteResult.totalStampDuty.toFixed(2) : null;      

        return qbeContact;
    }

    return {
        mergeContacts: mergeContacts
    };
}
